module.exports = __webpack_public_path__ + "media/images/arrow-right-9910289a.png";